// extracted by mini-css-extract-plugin
export default {"box":"errorPage_box__MyqLY","msgBox":"errorPage_msgBox__BGYKV","msgBox__msg":"errorPage_msgBox__msg__awRLL","btn":"errorPage_btn__KseYv"};